<template>
  <div></div>
</template>
<script>
export default {
  name: "Openid",
  data () {
    return {
      Code: "",
      State: "",
      Session_state: ""
    };
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search);

    this.Code = urlParams.get("code");
    this.State = urlParams.get("state");
    this.Session_state = urlParams.get("session_state");

    const redirectToOidcLogin = () => {
      sessionStorage.clear();
      window.location.replace(this.$serviceoidc.getOidc());
    };

    if (
      typeof this.Code === "undefined" ||
      this.Code === null ||
      this.Code === ""
    ) {
      redirectToOidcLogin();
      return false;
    }

    if (
      typeof this.State === "undefined" ||
      this.State === null ||
      this.State === ""
    ) {
      redirectToOidcLogin();
      return false;
    }

    // if (
    //   typeof this.Session_state === "undefined" ||
    //   this.Session_state === null ||
    //   this.Session_state === ""
    // ) {
    //  redirectToOidcLogin();
    //   return false;
    // }

    this.$storage.setOidcCode(this.Code);
    this.$storage.setOidcState(this.State);
    // this.$storage.setOidcSession_state(this.Session_state);

    this.$serviceoidc
      .postAccesToken(this.$storage.getOidcCode())
      .then(response => {
        if (response) {
          this.$serviceoidc.saveOidcTokens(response);
          this.$router.replace("/Home");
        } else {
          redirectToOidcLogin();
        }
      })
      .catch(() => {
        redirectToOidcLogin();
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Openid.vue